export default __webpack_public_path__ + "static/media/trans-4.47da50b7.jpg";